<script>
import VideoListItem from '@components/videoList/videoListItem'

export default {
  components: { VideoListItem },
  props: {
    videos: {
      type: Array,
      default: () => {},
    },
    zoom: {
      type: Boolean,
      default: false,
    },
    selectVideo: {
      type: Function,
      default: () => {},
    },
    removeManually: {
      type: Boolean,
      default: false,
    },
    uploadVideos: {
      type: Boolean,
      default: false,
    },
    selectManually: {
      type: Boolean,
      default: false,
    },
    idSelected: {
      type: String,
      default: '',
    },
    campaignSelection: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<template>
  <div>
    <div
      v-for="(i, mainIndex) in Math.ceil(videos.length / 4)"
      :key="mainIndex"
      class="video-list"
      :class="zoom && 'video-list-zoom'"
    >
      <VideoListItem
        v-for="(item, index) in videos.slice((i - 1) * 4, i * 4)"
        :key="index"
        :item-video="item"
        :action="selectVideo"
        :remove-manually="removeManually"
        :upload-videos="uploadVideos"
        :select-manually="selectManually"
        :id-selected="idSelected"
        :campaign-selection="campaignSelection"
      />
    </div>
  </div>
</template>
